/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: parkingLotsActions.ts
 🗓️ Created: 2026-05-02
 🧩 Description:
    Implementation of the PBX Applications module.
────────────────────────────────────────────────────────────────*/

import type { NavigateFunction } from 'react-router-dom';
import { deleteParkingLot } from './api/parkingLotsApi';

/**
 * Shared helpers for Parking Lots module actions.
 */

/**
 * Build the URL used to duplicate a Parking Lot in the form.
 * Pattern: /pbx/applications/parking/new?duplicate={id}
 */
export const getParkingLotDuplicateUrl = (id: string | number): string =>
  `/pbx/applications/parking/new?duplicate=${id}`;

/**
 * Navigate to the form in duplicate mode for the given parking lot id.
 */
export const navigateToParkingLotDuplicate = (
  navigate: NavigateFunction,
  id: string | number,
): void => {
  navigate(getParkingLotDuplicateUrl(id));
};

/**
 * Low-level API helper to delete a Parking Lot by id.
 * UI components are responsible for showing notifications and handling navigation/refresh.
 */
export const deleteParkingLotById = async (id: string | number): Promise<void> => {
  await deleteParkingLot(id);
};


